import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { usePage } from 'client/store'
import { getWebsiteHeaderMenuEntity } from 'client/store/page/pageSelectors'
import { MenuTargetEnum } from 'common/components/entities/Menu/enums/MenuTargetEnum'
import MenuInterface from 'common/components/entities/Menu/types/MenuInterface'
import { removeWebsiteMenuItemsByPageContentIds } from 'common/components/entities/Menu/utils/remove-website-menu-items'
import { getWebsitePageReplacement } from 'common/utils/website-replacements-utils'
import { useCallback } from 'react'

export const useWebsiteHeaderMenuPageItems = () => {
  const menuEntity = usePage(page => getWebsiteHeaderMenuEntity(page)) as
    | MenuInterface
    | undefined
  const updateEntity = useUpdateEntity<MenuInterface>()

  const addPageToHeaderMenu = useCallback(
    (pageContentId: number, pageName: string) => {
      if (!menuEntity) {
        return
      }

      updateEntity({
        ...menuEntity,
        menuItems: [
          ...menuEntity.menuItems,
          {
            text: pageName,
            link: getWebsitePageReplacement(pageContentId),
            target: MenuTargetEnum._self,
            subMenuItems: [],
            subMenuOpen: false,
          },
        ],
      })
    },
    [menuEntity, updateEntity],
  )

  const removeMenuPageItem = useCallback(
    (pageContentIds: number | number[]) => {
      if (!menuEntity) {
        return
      }

      const deletedPageContentIds = Array.isArray(pageContentIds)
        ? pageContentIds
        : [pageContentIds]

      if (!deletedPageContentIds.length) {
        return
      }

      const updatedMenuItems = removeWebsiteMenuItemsByPageContentIds(
        menuEntity.menuItems,
        deletedPageContentIds,
      )

      updateEntity({
        ...menuEntity,
        menuItems: updatedMenuItems,
      })
    },
    [menuEntity],
  )

  return {
    addPageToHeaderMenu,
    removeMenuPageItem,
  }
}
